import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, Package, XCircle } from "lucide-react";
import api, { money } from "../lib/api";
import { useCart } from "../context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) { navigate("/"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (data.status === "expired" || attempts > 8) { setStatus("failed"); return; }
      } catch { if (attempts > 8) { setStatus("failed"); return; } }
      attempts += 1;
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0B0B0C] pt-32 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {status === "checking" && (
          <><div className="w-12 h-12 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-6" />
            <p className="font-serif-lux text-2xl text-[#FAFAF7]">Confirming your payment…</p></>
        )}
        {status === "paid" && (
          <><CheckCircle2 size={64} className="text-[#D4AF37] mx-auto mb-6" />
            <p className="eyebrow mb-3">ORDER CONFIRMED</p>
            <h1 className="font-serif-lux text-4xl font-light text-[#FAFAF7] mb-4">Merci beaucoup</h1>
            <p className="text-[#FAFAF7]/60 mb-8">Your fragrance is being lovingly packaged. A confirmation has been sent to your email.</p>
            <div className="flex gap-3 justify-center">
              <Link to="/account?tab=orders" className="btn-gold px-7 py-3 rounded-full text-sm">View Orders</Link>
              <Link to="/shop" className="btn-outline-gold px-7 py-3 rounded-full text-sm">Continue Shopping</Link>
            </div></>
        )}
        {status === "failed" && (
          <><XCircle size={64} className="text-[#58111A] mx-auto mb-6" />
            <h1 className="font-serif-lux text-3xl text-[#FAFAF7] mb-4">Payment not completed</h1>
            <Link to="/checkout" className="btn-gold px-7 py-3 rounded-full text-sm inline-block">Try Again</Link></>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B0B0C] pt-32 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <XCircle size={64} className="text-[#58111A] mx-auto mb-6" />
        <h1 className="font-serif-lux text-4xl font-light text-[#FAFAF7] mb-4">Payment Cancelled</h1>
        <p className="text-[#FAFAF7]/60 mb-8">Your bag is saved. Return whenever you're ready.</p>
        <Link to="/checkout" className="btn-gold px-7 py-3 rounded-full text-sm inline-block">Back to Checkout</Link>
      </div>
    </div>
  );
}

export function OrderConfirmed() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  return (
    <div className="min-h-screen bg-[#0B0B0C] pt-32 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <CheckCircle2 size={64} className="text-[#D4AF37] mx-auto mb-6" />
        <p className="eyebrow mb-3">ORDER CONFIRMED</p>
        <h1 className="font-serif-lux text-4xl font-light text-[#FAFAF7] mb-4">Merci beaucoup</h1>
        <p className="text-[#FAFAF7]/60 mb-2">Your demo order has been placed successfully.</p>
        {orderId && <p className="text-xs text-[#FAFAF7]/40 mb-8 font-mono-lux">Order #{orderId.slice(-8)}</p>}
        <div className="flex gap-3 justify-center">
          <Link to="/account?tab=orders" className="btn-gold px-7 py-3 rounded-full text-sm">View Orders</Link>
          <Link to="/shop" className="btn-outline-gold px-7 py-3 rounded-full text-sm">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
